<template>
    <div class="all-height" style="min-width: 1300px;min-height: 755px">
        <el-main class="all-height">
            <el-row :gutter="20" style="height: 50%">
                <el-col :span="16" class="all-height">
                    <el-row :gutter="20" style="height: 65%">
                        <!-- 采购流程 -->
                        <el-col :span="12" style="height: calc(100% - 20px);min-height: 200px;">
                            <div class="all-height block-show process-show">
                                <h1>采购流程</h1>
<!--                                <img src="../assets/img/purchasing-process.png" height="100%"/>-->
                            </div>
                        </el-col>
                        <!-- 采购须知 -->
                        <el-col :span="12" style="height: calc(100% - 20px);min-width: 420px;min-height: 200px;">
                            <div class="all-height block-show">
                                <h1>采购须知</h1>
                                <ul>
                                    <li><div><span class="point-show"></span><p>采购人员整理需要询价的物料，并制作询价单</p></div></li>
                                    <li><div><span class="point-show"></span><p>根据公司采购要求，设定询价供应商</p></div></li>
                                    <li><div><span class="point-show"></span><p>下发询价单给供应商竞价</p></div></li>
                                    <li><div><span class="point-show"></span><p>对价格经行汇总和审批，确定最优价格</p></div></li>
                                </ul>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px;height: 35%;">
                        <el-col :span="12" style="height: calc(100% - 40px);min-height: 80px">
                            <div class="all-height block-show incomplete-btn btn-show" @click="changeBottomTable('nohandleOrder')">
                                <img src="../assets/img/incomplete-order.png" width="85px"/>
                                <div class="btn-box"><h1>{{orderCount.noHandleQty}}</h1><h2>未处理订单</h2></div>
                            </div>
                        </el-col>
                        <el-col :span="12" style="height: calc(100% - 40px);min-height: 80px">
                            <div class="all-height block-show complete-btn btn-show " @click="changeBottomTable('finishOrder')">
                                <img src="../assets/img/complete-order.png" width="80px"/>
                                <div class="btn-box"><h1>{{orderCount.finishQty}}</h1><h2>已处理订单</h2></div>
                            </div>
                        </el-col>
<!--                        <el-col :span="8" style="height: calc(100% - 40px);min-height: 80px">-->
<!--                            <div class="all-height block-show return-btn btn-show " @click="changeBottomTable('reviewOrder')">-->
<!--                                <img src="../assets/img/return-order.png" width="80px"/>-->
<!--                                <div class="btn-box"><h1>{{orderCount.reviewQty}}</h1><h2>待审核订单</h2></div>-->
<!--                            </div>-->
<!--                        </el-col>-->
                    </el-row>
                </el-col>
                <el-col :span="8" style="height: calc(100% - 20px);min-height: 280px">
                    <div class="all-height block-show" v-show="showMsg">
                        <div class="close-bar">
                            <h1>{{msg_frmData.msgTitle}}</h1>
                            <span style="font-size: 25px; line-height: 25px" @click="showMsg = false">×</span>
                        </div>
                        <div class="msg-content">
                            <div>
                                <p>
                                    {{msg_frmData.msgContent}}
                                </p>
                                <div style="margin-top: 20px;" v-show="msg_frmData.files && msg_frmData.files.length > 0">
                                    <p>附件：</p>
                                    <ul>
                                        <li v-for="item in msg_frmData.files" :key="item.pkFileUpload"><el-button type="text" @click="downFile(item)">{{item.oldName}}</el-button></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="all-height block-show" v-show="!showMsg">
                        <h1>通知公告栏</h1>
                        <div style="height: calc(100% - 70px); overflow-y: auto;width: 100%;">
                            <div style="height: 100%;width: 100%;">
                                <el-table
                                    :data="noticeList"
                                    style="width: 100%"
                                    :show-header="false"
                                    @row-click="viewContent"
                                    :row-style="{cursor: 'pointer'}"
                                >
                                    <el-table-column label="标题" :show-overflow-tooltip='true' align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text">{{scope.row.msgTitle}}</el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="发布日期" align="center">
                                        <template slot-scope="scope">
                                            <span style="margin-left: 10px">{{ dateFormat(scope.row.createTime) }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>

                    </div>
                </el-col>
            </el-row>
            <!-- bottomTable -->
            <div class="table-show block-show" style="min-height: 300px">
                <h1>{{bottomTableTitle}}<span><a href="#" @click="showMoreOrder">更多</a></span></h1>
                <el-table
                        :data="displayOrderDetailList"
                        style="width: 100%">
                    <el-table-column align="center" width="150" prop="orderNo" label="订单编号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="100" prop="rowNo" label="行项目号" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="150"  label="物料编码" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{scope.row.sapMtrlCode.substr(-10,10)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="350"  prop="sapMtrlName" label="物料名称" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="100"  prop="qty" label="数量" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="100"  prop="uom" label="单位" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="100"  prop="price" label="单价" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="250" prop="compName" label="所属公司" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center" width="120" prop="expectDate" label="交货日期" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column align="center"  prop="vendorRemark" label="供应商备注" :show-overflow-tooltip="true"></el-table-column>


                </el-table>
            </div>
        </el-main>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import dayjs from "dayjs"
    export default {
        name: 'DashBoard',
        data() {
            return {
                msg_frmData: {},
                labelWidth: '60px',
                bottomTableTitle: '未处理订单',
                bottomTableType: 'nohandleOrder',
                showMsg: false
            }
        },
        computed: {
            ...mapState('login', ['noticeList', 'orderCount', 'displayOrderDetailList'])
        },
        methods: {
            changeBottomTable(type) {
                this.bottomTableType = type;
                if (type === 'nohandleOrder'){
                    this.bottomTableTitle = "未处理订单";
                    this.$store.dispatch('login/listOrderDetailLimit',{statusX: 0});
                } else if (type === 'finishOrder') {
                    this.bottomTableTitle = "已处理订单";
                    this.$store.dispatch('login/listOrderDetailLimit',{statusX: 1});
                }
                // else if (type === 'reviewOrder') {
                //     this.bottomTableTitle = "待审核订单";
                //     this.$store.dispatch('login/listOrderDetailLimit',{statusX: '待审核'});
                // }
            },
            showMoreOrder() {
                if(this.bottomTableType === 'nohandleOrder') {
                    this.$router.push('/order/incomplete');
                } else if (this.bottomTableType === 'finishOrder') {
                    this.$router.push('/order/complete');
                } else if (this.bottomTableType === 'reviewOrder') {
                    this.$router.push('/order/returnOrder');
                }
            },
            viewContent(row) {
                this.msg_frmData.msgTitle = row.msgTitle;
                this.msg_frmData.msgContent = row.msgContent;
                this.msg_frmData.files = row.fileUploads;
                this.showMsg = true;
            },
            downFile(item) {
                this.$store.dispatch('msg/messageManagement/download',{pkFileUpload: item.pkFileUpload});
            },
            dateFormat(val) {
                if (val) {
                    return dayjs(val).format('YYYY-MM-DD HH:mm');
                } else {
                    return '';
                }
            },
        },
        created() {
            this.$store.dispatch('login/initWebSocket');
            this.$store.dispatch('login/getNoticeList');
            this.$store.dispatch('login/getNoReadMessageList');
            this.$store.dispatch('login/getCountOfSomeStatusX');
            this.$store.dispatch('login/listOrderDetailLimit',{statusX: 0});
        }
    }
</script>

<style scoped>
    .middle-block {
        height: 100%;
    }
    .block-show {
        border-radius: 4px;
        background-color: white;
        padding: 10px;
    }
    .block-show h1 {
        color: #55C1FF;
        font-size: 16px;
        display: block;
        height: 50px;
        letter-spacing: 2px;
    }
    .block-show h1 span {
        float: right;
        color: black;
        font-weight: normal;
    }
    .block-show ul li div {
        width: 100%;
        position: relative;
        height: 20px;
        margin-left: 40px;
        margin-bottom: 20px;
    }
    .block-show ul li span {
        float: left;
    }
    .block-show ul li p {
        float: left;
        text-indent: 2em;
    }
    .table-show {
        margin-top: 20px;
        height: calc(50% - 40px);
    }
    .point-show {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #25A5EE;
        border-radius: 50%;
        position: absolute;
        top: calc(50% - 5px);
    }
    .noice-box {
        text-align: center;
        margin-top: 20px;
    }
    .incomplete-btn {
        border-left: 2px solid #76C146;
    }
    .incomplete-btn h1 {
        color: #76C146;
    }
    .complete-btn {
        border-left: 2px solid #F8AF01;
    }
    .complete-btn h1 {
        color: #F8AF01;
    }
    .return-btn {
        border-left: 2px solid #8579DD;
    }
    .return-btn h1 {
        color: #8579DD;
    }
    .btn-show {
        display: flex;
        align-items: center;
        padding-left: 20px;
        cursor: pointer;
    }
    .btn-show:hover {
        color: grey;
        border-left: 2px solid grey;
    }
    .btn-box {
        width: calc(100% - 40px);
        height: 100%;
        text-align: center;
    }
    .btn-box h1 {
        font-size: 36px;
        font-weight: normal;
        margin-top: 12px;
    }
    .btn-box h2 {
        font-size: 20px;
        font-weight: normal;
    }
    .el-table td, .el-table th {
        text-align: left;
    }
    .process-show {
        background: white url("../assets/img/purchasing-process.png") no-repeat center;
        background-size: 80%;
    }
    .el-table .el-button{
        padding: 0px;
    }
    .close-bar {
        height: 25px;
        width: 100%;
        position: relative;
    }
    .close-bar h1 {
        width: calc(100% - 25px);
        height: 25px;
        -webkit-line-clamp: 1;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        white-space: normal;
    }
    .close-bar span {
        display: block;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
    }
    .close-bar span:hover {
        color: #4885CA;
    }
    .msg-content {
        height: calc(100% - 20px);
        padding: 8px;
        overflow: hidden;
        word-wrap:break-word;
    }
    .msg-content div:first-child {
        height: calc(100% - 50px);
        width: 100%;
        overflow-y:scroll;
    }
</style>
